import React from 'react';
import './nav-bar.style.css';
import {
    Link, Redirect, withRouter
} from 'react-router-dom'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Login from '../login/login.component'
import Logout from '../logout/logout.component'

import { Modal, ModalMenu } from '../modal/modal.component'

import UserContext from '../../utils/userContext';

import axios from 'axios'

library.add(fas);

export default class NavBar extends React.Component {
    static contextType = UserContext
    constructor(props) {
        super(props);
        this.state = {
            textSearch: "",
            targetRedirect: "",
            showingModal: false
        };

        this.onCloseModal = this.onCloseModal.bind(this)
        this.onShowLoginModal = this.onShowLoginModal.bind(this)
        this.onShowRightMenuModal = this.onShowRightMenuModal.bind(this)
        this.onShowPageMenuModal = this.onShowPageMenuModal.bind(this)

        this.searchRedirect = this.searchRedirect.bind(this)

    }

    onTextChange(event) {
        this.setState({ textSearch: event.target.value })
    }

    searchRedirect() {
        this.setState({ targetRedirect: `/search?q=${(this.state.textSearch)}`, textSearch: "" })
    }

    onEnter(event) {
        var code = event.keyCode || event.which;
        if (code === 13) {
            this.searchRedirect()
        }
    }

    componentDidMount() {

    }

    onCloseModal() {
        // console.log("close")
        this.setState({ showingModal: false })
    }

    onRedirect() {
        if (this.state.targetRedirect !== "") {
            return <Redirect to={this.state.targetRedirect} />
        }
    }


    onShowLoginModal() {
        this.setState({ showingModal: "login" })
    }

    onShowRightMenuModal() {
        this.setState({ showingModal: "rightMenu" })
    }

    onShowPageMenuModal() {
        this.setState({ showingModal: "pageMenu" })
    }






    componentDidMount() {

        if (!this.context.userData.loggedIn) {

            let self = this;
            axios({
                method: 'post',
                url: `https://www.borntodev.com/wp-json/devblog/v1/login`,
                headers: {
                    'Content-Type': 'multipart/form-data',
                }
            })
                .then(function (response) {

                    let data = response.data.data;

                    self.updateToken(data)

                }).catch(function (response) {

                });
        }
    }

    updateToken(data) {


        data["loggedIn"] = true
        localStorage.setItem("btd-bdt", JSON.stringify(data))
        this.context.setUserData(data);

    }


    render() {
        return (
            <>
                {this.state.showingModal === "login" ? <Modal closeModal={this.onCloseModal} modalComponent={<Login goHome={this.props.goHome} onCloseModal={this.onCloseModal} />} /> : <></>}

                <div className="nav-bar-wrap">
                    {this.onRedirect()}
                    <div className="nav-bar inner-bg-color">
                        <div className="nav-bar-menu-segment">


                            <a href="/c/" >
                                <img className="nav-bar-logo" src="https://www.borntodev.com/wp-content/uploads/2020/11/White_Yellow_Creator.png" />
                            </a>
                            <Link to="/tags/">
                                <div className="nav-bar-menu">
                                    แท็ก
                        </div>
                            </Link>
                        </div>

                        <div className="nav-bar-menu-segment">
                            <div className="nav-bar-search-wrap">
                                <input className="nav-bar-search-box" placeholder="ค้นหา..." type="text" id="fname" name="fname" autocomplete="off" onKeyPress={this.onEnter.bind(this)} onChange={this.onTextChange.bind(this)} value={this.state.textSearch} />
                                <div className="nav-bar-search" onClick={this.searchRedirect}>
                                    <FontAwesomeIcon style={{ color: "white" }} icon={['fas', 'search']} />
                                </div>
                            </div>

                            {this.context.userData.loggedIn ?
                                <Link to={"/newpost"}>
                                    <div className="nav-bar-new-post">เขียนบทความ</div>
                                </Link> :
                                <div className="nav-bar-new-post" onClick={this.onShowLoginModal}>เขียนบทความ</div>

                            }
                            <div className="nav-bar-user">
                                {this.context.userData.loggedIn ?
                                    <>

                                        <div className="nav-bar-name" >{this.context.userData.displayName}</div>
                                        <div>
                                            {this.state.showingModal === "rightMenu" ? <ModalMenu closeModal={this.onCloseModal} type={'modal-right'} modalComponent={<ProfileMenu setUserData={this.props.setUserData} closeModal={this.onCloseModal} goHome={this.props.goHome} niceName={this.context.userData.nicename} />} /> : <></>}
                                            <div className="nav-bar-userimage " onClick={this.onShowRightMenuModal} style={{ backgroundImage: `url(${this.context.userData.profileImage})` }}>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="nav-bar-login" onClick={this.onShowLoginModal}>
                                            เข้าสู่ระบบ
                                        </div>


                                    </>


                                }

                            </div>
                        </div>
                    </div>
                </div >
                <div className="small-nav-bar-wrap">
                    <div className="small-nav-bar">
                        <div>
                            {this.state.showingModal === "pageMenu" ? <ModalMenu closeModal={this.onCloseModal} type={'modal-left'} modalComponent={<PageMenu setUserData={this.props.setUserData} closeModal={this.onCloseModal} goHome={this.props.goHome} niceName={this.context.userData.nicename} />} /> : ""}
                            <div className="nav-bar-logo-small" onClick={this.onShowPageMenuModal}>
                            </div>
                        </div>

                        <div className="nav-bar-menu-segment">
                            <div className="nav-bar-search-wrap">
                                <input className="small-nav-bar-search-box" placeholder="ค้นหา..." type="text" id="fname" name="fname" autocomplete="off" onKeyPress={this.onEnter.bind(this)} onChange={this.onTextChange.bind(this)} value={this.state.textSearch} />
                                <div className="nav-bar-search" onClick={this.searchRedirect}>
                                    <FontAwesomeIcon style={{ color: "white" }} icon={['fas', 'search']} />
                                </div>
                            </div>

                            <div className="small-nav-bar-user">
                                {this.context.userData.loggedIn ?
                                    <div>
                                        {this.state.showingModal === "rightMenu" ? <ModalMenu closeModal={this.onCloseModal} type={'modal-right'} modalComponent={<ProfileMenu setUserData={this.props.setUserData} closeModal={this.onCloseModal} goHome={this.props.goHome} niceName={this.context.userData.nicename} />} /> : <></>}
                                        <div className="nav-bar-userimage " onClick={this.onShowRightMenuModal} style={{ backgroundImage: `url(${this.context.userData.profileImage})` }}>
                                        </div>
                                    </div>
                                    :
                                    <>
                                        <div className="nav-bar-login" onClick={this.onShowLoginModal}>
                                            เข้าสู่ระบบ
                                        </div>

                                    </>


                                }

                            </div>
                        </div>
                    </div>
                </div>
            </>
        )
    }
}


const ProfileMenu = (props) => (
    <div className="profile-menu">
        <Link to={"/newpost"}>
            <div className="profile-menu-choice" onClick={props.closeModal}>เขียนบทความ</div>
        </Link>
        <Link to={`/${props.niceName}`}>
            <div className="profile-menu-choice" onClick={props.closeModal}>บทความของฉัน</div>
        </Link>
        <Link to={"/list"}>
            <div className="profile-menu-choice" onClick={props.closeModal}>บทความที่บันทึก</div>
        </Link>
        <div className="mt-10px">
            <Logout setUserData={props.setUserData} goHome={props.goHome} closeModal={props.closeModal} />
        </div>
    </div>
)

const PageMenu = (props) => (
    <div className="page-menu">
        <Link to={"/"}>
            <div className="profile-menu-choice" onClick={props.closeModal}>หน้าหลัก</div>
        </Link>
        <Link to={`/tags`}>
            <div className="profile-menu-choice" onClick={props.closeModal}>แท็ก</div>
        </Link>

    </div>
)



export { NavBar };

